import { HttpInterceptorFn } from '@angular/common/http';

/**
 * Adjunta el JWT firmado (emitido por /auth/login o /auth/register) como
 * Authorization: Bearer <token>. Antes este interceptor mandaba el id de
 * usuario en texto plano (x-user-id) leído de localStorage, que cualquiera
 * podía editar desde las devtools para impersonar a otro usuario — el
 * backend ya no acepta ese header para identidad.
 */
export const authHeaderInterceptor: HttpInterceptorFn = (req, next) => {
  const token = localStorage.getItem('auth_token');
  if (!token) {
    return next(req);
  }

  const authReq = req.clone({
    setHeaders: {
      Authorization: `Bearer ${token}`,
    },
  });

  return next(authReq);
};
